// extracted by mini-css-extract-plugin
export default {"qrContainer":"C7Uxw2x8Q0kxz8LH_8dk"};